import React from "react";
import { Pagination } from "react-bootstrap";

function MainPagination({currentPage, dataPerPage = 8, total, count = 6, onChangePage = (page) => {} }){

    const getTotalPages = () => {
        return Math.ceil(total / dataPerPage);
    }

    return(
        <Pagination size="sm">
            <Pagination.Prev onClick={() => onChangePage(currentPage - 1)} linkStyle={{ color: 'green', cursor: 'pointer' }} disabled={currentPage <= 0} />
            {
                Array.from({ length: getTotalPages() }).map((_, index) => {
                    //let addition = currentPage - count < 0 ? 1 : currentPage - count;
                    //let value = index + addition;
                    return(
                        <Pagination.Item onClick={() => onChangePage(index)} key={index} linkStyle={ currentPage === index ? { color: 'white', backgroundColor: 'green', cursor: 'pointer' } : { color: 'green', cursor: 'pointer' }}>{index + 1}</Pagination.Item>
                    );
                })
            }
            <Pagination.Next onClick={() => onChangePage(currentPage + 1)} linkStyle={{ color: 'green', cursor: 'pointer' }} disabled={currentPage >= getTotalPages() - 1 }/>
            
        </Pagination>
    );

}

export default MainPagination;